import { NavigationFlow } from "@b2bportal/core-utilities";
import type { FlightExchangeSteps } from "./FlightExchangeNavigationFlowProvider";

const useGoToNextStep = (currentStep: FlightExchangeSteps) => {
  return NavigationFlow.useGoToNextStep<FlightExchangeSteps>(currentStep);
};

const useGoToStep = () => {
  return NavigationFlow.useGoToStep<FlightExchangeSteps>();
};

export const FlightsExchangeNavigationFlow = {
  useGoToNextStep,
  useGoToStep,
};
